<template>
  <div class="proFunction">
    <iframe  ref="prints" :src='srcHttp' frameborder="0">
    </iframe>
    <div class="btnDiv"><button class="retBtn" @click="go" style="display: none">返回</button></div>
  </div>
</template>
<script>
import Iframe from "@/components/CommonComponents/Iframe";
export default {
  name: "proFunction",
  components: {Iframe},
  data() {
    return {
      srcHttp: '',
      list: []
    }
  },
  created() {
    let arr =  [
          '',//材料
          'https://spcvp.visumall.com/public/abbeNumber.html',//阿贝数
          'https://spcvp.visumall.com/public/SingleVision.html',//单光
          '',//渐进
          'https://spcvp.visumall.com/public/AntiFatigue.html',//抗疲劳
          'https://spcvp.visumall.com/public/myopiaControl.html',//儿童近视控制
          'https://spcvp.visumall.com/public/DriveEx.html',//驾驶
          'https://spcvp.visumall.com/public/Polarized.html',//偏光 已废弃
          'https://spcvp.visumall.com/public/AntiBlue.html',//防蓝光
          'https://spcvp.visumall.com/public/Drive.html?search=1',//快变色
          'https://spcvp.visumall.com/public/LayerFinger.html',//防尘防静电
          'https://spcvp.visumall.com/public/Layer.html?search=1',//防水
          'https://spcvp.visumall.com/public/Layer.html?search=2',//防雾
          'https://spcvp.visumall.com/public/LayerCanvas.html',//抗磨损
          'https://spcvp.visumall.com/public/Layer.html?search=3',//减反射
          'https://spcvp.visumall.com/public/Drive.html?search=1',//全染色
          'https://spcvp.visumall.com/public/Drive.html?search=1',//渐变色
          'https://spcvp.visumall.com/public/Drive.html?search=1',//驾驶1
          'https://spcvp.visumall.com/public/Drive.html?search=2',//驾驶2
          'https://spcvp.visumall.com/public/sceneEexperience.html',//场景体验 20
        ];
    this.list = arr;
    this.srcHttp = this.list[this.$route.query.proId - 1]
  },
  mounted() {

  },
  methods: {
    go() {
      this.$router.go(-1);
    }
  }
}
</script>
<style scoped lang="scss">
  .proFunction {
    width: 100%;
    height: 76vh;
  }
  iframe {
    width: 100%;
    height: 100%;
  }
  .btnDiv {
    width: 100%;
    margin-top: 0;
    display: flex;
    justify-content: center;
  }
  .retBtn {
    padding: 10px 80px;
    background: transparent;
    border: 1px solid #333;
    color: #333;
    font-size: 18px;
  }
</style>
